<script setup>

import {useLanguageStore} from "@/pinia";

const props = defineProps(['data']);
const emits = defineEmits(['modalSetter']);
const languageStore = useLanguageStore();

</script>

<template>
  <button class="insertButton" @click="emits('modalSetter', data)">{{languageStore.get('register')}}</button>
</template>

<style scoped>
  .insertButton{
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: #052C65;
    margin: 10px;
    min-width: 70px;
    height: 30px;
    padding: 0 12px;
    white-space: nowrap;
  }
</style>